import React from 'react';
import * as PropTypes from 'prop-types';
import { ContentBox } from 'components/content-box';
import { Link } from 'react-router-dom';
import { Carousel } from 'pages/home.page/video-carousel/carousel';
import { channel2url } from 'common/api/models/navigation-item.model';

export const ChannelOverview = (props) => {
  const { overview, currentChannelId, channels, withRelatedVideos } = props;
  const { videoLists } = overview;

  if (videoLists.length === 0 || (videoLists.length === 1 && videoLists[0].id === currentChannelId)) {
    return null;
  }

  const channelCarousels = videoLists.reduce((acc, videoList) => {
    if (videoList.id !== currentChannelId) {
      const channel = channels.find(({ id }) => id === Number(videoList.id));
      const url = channel2url(channel);
      const { id, name } = channel;

      acc.push(
        <div key={id} data-e2e={`channel-container`} className="channel-container">
          <Link className="title" to={url + '#top'} data-e2e={`channel-url-${id}`}>
            {name}
          </Link>
          <Carousel ariaLabel={name} channelId={id} baseUrl={url} withRelatedVideos={withRelatedVideos} />
        </div>
      );
    }

    return acc;
  }, []);

  return (
    <ContentBox className="channels">
      <div className="channel-overview-title" data-e2e="channels-title">
        {overview.label}
      </div>
      {channelCarousels}
    </ContentBox>
  );
};

ChannelOverview.propTypes = {
  withRelatedVideos: PropTypes.bool,
  overview: PropTypes.object.isRequired,
  currentChannelId: PropTypes.number,
  channels: PropTypes.array,
};
